import { useEffect, useState } from "react";

const QUIZ_ANSWER_COUNTER_KEY = "QUIZ_ANSWER_COUNTER_KEY";

export const useAnswersCounter = () => {
  const [answers, setAnswers] = useState({});

  useEffect(() => {
    const storagedAnswers = sessionStorage.getItem(QUIZ_ANSWER_COUNTER_KEY);
    if (storagedAnswers) {
      setAnswers(JSON.parse(storagedAnswers));
    }
  }, []);

  const countAnswer = (question_id) => {
    setAnswers((prevAnswers) => {
      const newAnswers = { ...prevAnswers, [question_id]: true };
      sessionStorage.setItem(
        QUIZ_ANSWER_COUNTER_KEY,
        JSON.stringify(newAnswers),
      );
      return newAnswers;
    });
  };

  const counter = answers ? Object.keys(answers) : 0;

  return {
    counter,
    countAnswer,
  };
};
